import { render, staticRenderFns } from "./PeoplePage.vue?vue&type=template&id=129d4738&scoped=true&"
import script from "./PeoplePage.vue?vue&type=script&lang=js&"
export * from "./PeoplePage.vue?vue&type=script&lang=js&"
import style0 from "./PeoplePage.vue?vue&type=style&index=0&id=129d4738&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129d4738",
  null
  
)

export default component.exports